import * as React from "react"
import { FaPlay } from "react-icons/fa"
import { Flex } from "@chakra-ui/react"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"

interface CirclePlayIconProps {
  customStyles?: React.CSSProperties
  isActive: boolean
}

const _CirclePlayIcon: React.FC<CirclePlayIconProps> = ({
  customStyles,
  isActive
}) => {
  const roomStyles = useRecoilValue(brandingSelector)
  return (
    <Flex
      color={
        isActive
          ? `${roomStyles?.accessButtonSelectedTextColor ?? "#000"}`
          : "#FFFFFF"
      }
      border={`2px solid ${isActive ? `${"white"}` : "#FFFFFF"}`}
      background={
        isActive
          ? roomStyles?.accessButtonSelectedColor ?? "#edf2f7"
          : "rgba(0, 0, 0, 0.2)"
      }
      borderRadius="50%"
      padding="0.3rem"
      justifyContent="center"
      alignItems="center"
      onMouseDown={e => e.preventDefault()}
      style={{ ...customStyles }}
      className="icon-ios"
    >
      <FaPlay
        size="0.75rem"
        style={{ paddingLeft: "0.11rem" }}
        className="icon-ios"
      />
    </Flex>
  )
}

export const CirclePlayIcon = React.memo(_CirclePlayIcon)
